import { ErrorMessage } from 'formik';
import React from 'react';

import { cn } from '@dashboard/lib/utils';

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/** @param {{ children?: React.ReactNode; className?: string }} props */
const Error = ({ children, className }) => {
  const inner = typeof children === 'string' ? capitalizeFirstLetter(children) : children;

  return <p className={cn('mt-1 text-sm text-destructive', className)}>{inner}</p>;
};

const FormError = ({ name, ...props }) => <ErrorMessage component={Error} name={name} {...props} />;

export const FormErrorFromProps = ({ error, touched }) => {
  if (!error || !touched) return null;
  return <Error>{error}</Error>;
};

export const FormErrorBase = Error;
export default FormError;
